<!-- <div *ngIf="false" class="flex justify-center items-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="container px-4 py-7">
  <div class="form-container w-full">
    <div class="p-6 bg-white shadow-lg rounded-md w-full">
      <h2 class="text-2xl font-bold mb-4">Create Conduit</h2>
      <form [formGroup]="conduitForm" (ngSubmit)="onSubmit()">
        <div class="mb-4 form-group">
          <label for="size" class="block text-sm font-medium text-gray-700"
            >Size:</label
          >
          <input
            pInputText
            id="size"
            formControlName="size"
            class="w-full mt-1"
          />
          <small
            *ngIf="
              conduitForm.get('size')?.invalid &&
              conduitForm.get('size')?.touched
            "
            class="text-red-500"
          >
            Size is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label for="status" class="block text-sm font-medium text-gray-700"
            >Status:</label
          >
          <input
            pInputText
            id="status"
            formControlName="status"
            class="w-full mt-1"
          />
          <small
            *ngIf="
              conduitForm.get('status')?.invalid &&
              conduitForm.get('status')?.touched
            "
            class="text-red-500"
          >
            Status is required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label
            for="coordinates"
            class="block text-sm font-medium text-gray-700"
            >Coordinates:</label
          >
          <textarea
            pTextarea
            id="coordinates"
            formControlName="coordinates"
            class="w-full mt-1 h-20 rounded-md border-gray-300 shadow-xs"
          ></textarea>
          <small
            *ngIf="
              conduitForm.get('coordinates')?.invalid &&
              conduitForm.get('coordinates')?.touched
            "
            class="text-red-500"
          >
            Coordinates are required
          </small>
        </div>

        <div class="mb-4 form-group">
          <label
            for="handholeId_start"
            class="block text-sm font-medium text-gray-700"
            >Start Handhole:</label
          >
          <input
            pInputText
            id="handholeId_start"
            formControlName="handholeId_start"
            class="w-full mt-1"
          />
        </div>

        <div class="mb-4 form-group">
          <label
            for="handholeId_end"
            class="block text-sm font-medium text-gray-700"
            >End Handhole:</label
          >
          <input
            pInputText
            id="handholeId_end"
            formControlName="handholeId_end"
            class="w-full mt-1"
          />
        </div>

        <div class="mb-4 form-group">
          <label for="couplings" class="block text-sm font-medium text-gray-700"
            >Couplings:</label
          >
          <input
            pInputText
            id="couplings"
            formControlName="couplings"
            class="w-full mt-1"
          />
        </div>

        <div class="mb-4 form-group">
          <label for="notes" class="block text-sm font-medium text-gray-700"
            >Notes:</label
          >
          <textarea
            pTextarea
            id="notes"
            formControlName="notes"
            class="w-full mt-1 h-20 rounded-md border-gray-300"
          ></textarea>
        </div>

        <div class="flex justify-start py-4">
          <button
            pButton
            type="submit"
            [disabled]="conduitForm.invalid"
            class="primary-btn rounded-md"
          >
          Update
        </button>
        </div>
      </form>
    </div>
  </div>
</div> -->


<p-dialog
  [(visible)]="displayTaskModal"
  modal="true"
  header="Add Task"
  [style]="{ width: '50vw',}"
  [dismissableMask]="true"
>
  <form [formGroup]="taskForm">
    <div class="grid grid-cols-2 gap-4 p-4">
      <!-- Service Name -->
      <div>
        <label class="block text-gray-600 mb-1">Service Name</label>
        <input pInputText formControlName="serviceName" placeholder="Service Name" class="w-full" />
      </div>

      <!-- Client Name & Photo -->
      <div>
        <label class="block text-gray-600 mb-1">Client's Name & Photo</label>
        <div class="flex items-center gap-2">
          <img [src]="clientPhoto" alt="Client" class="w-8 h-8 rounded-full object-cover self-center" />
          <input pInputText formControlName="clientName"  class="w-full" />
        </div>
      </div>

      <!-- Due Date -->
      <div class="w-full">
        <label class="block text-gray-600 mb-1">Due Date</label>
        <p-calendar formControlName="dueDate" showIcon="true" [ngClass]="'w-full'" />
      </div>

      <!-- Status -->
      <div>
        <label class="block text-gray-600 mb-1">Status</label>
        <p-dropdown
          formControlName="status"
          [options]="statusOptions"
          placeholder="Select Status"
          class="w-full"
        ></p-dropdown>
      </div>

      <!-- Items -->
      <div>
        <label class="block text-gray-600 mb-1">Items</label>
        <p-dropdown
          formControlName="items"
          [options]="itemOptions"
          class="w-full"
        ></p-dropdown>
      </div>

      <!-- Total -->
      <div>
        <label class="block text-gray-600 mb-1">Total</label>
        <input pInputText formControlName="total"  class="w-full" />
      </div>

      <!-- Order ID -->
      <div class="col-span-2">
        <label class="block text-gray-600 mb-1">Order ID</label>
        <input pInputText formControlName="orderId"  class="w-full" />
      </div>
    </div>
  </form>

  <!-- Footer Buttons -->
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" (click)="closeTaskModal.emit()"></p-button>
      <p-button label="Save" icon="pi pi-check" severity="primary" (click)="saveChanges()"></p-button>
    </div>
  </ng-template>
</p-dialog>